import { FC, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDepartmentContactStore } from "../../../hooks/useDepartmentContactStore";
import { maskRUT } from "../../../toolbox/helpers/rut-helper";
import { useSelector } from "react-redux";
import { selectHeaderState } from "../../../redux/slices/headerSlice";
import { DepartmentContact } from "../../../types/slices/departmentContactType";
import { Grid } from "@mui/material";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import { ModalConfirm } from "../../../components/common/ModalConfirm/ModalConfirm";
import { ApiStatus } from "../../../types/api/status";
import { useDepartmentStore } from "../../../hooks/useDepartmentStore";

const columns = [
    { type: 'options', field: 'options', align: 'center', label: 'Opciones', },
    { type: 'text', field: 'name', align: 'center', label: 'Nombre' },
    {
        type: 'text', field: 'rut', align: 'center', label: 'RUT',
        format: (row) => maskRUT(row.rut)
    },
    { type: 'text', field: 'email', align: 'center', label: 'Correo' },
    { type: 'text', field: 'phone', align: 'center', label: 'Celular' },
    { type: 'detail', field: 'detail', align: 'center', label: '' },
];

export const DepartmentContactList: FC = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const { search } = useSelector(selectHeaderState)
    const { selectedDepartment } = useDepartmentStore()
    const { status, departmentContacts, getDepartmentContacts, setSelectedContactDepartment,
        deleteDepartmentContact } = useDepartmentContactStore()

    const [rowSelected, setRowSelected] = useState<DepartmentContact | undefined>(undefined)
    const [loading, setLoading] = useState<boolean>(false)
    const [showModalConfirm, setShowModalConfirm] = useState<boolean>(false)

    useEffect(() => {
        getDataAPI()
    }, [])

    const getDataAPI = async () => {
        setLoading(true)
        await getDepartmentContacts({
            iddepartment: id
        })
        setLoading(false)
    }

    const onAdd = () => {
        setSelectedContactDepartment(undefined)
        navigate(`/department-contact/form/${id}`)
    }

    const onEdit = (rowSelected) => {
        setSelectedContactDepartment(rowSelected)
        navigate(`/department-contact/form/${id}`)
    }

    const onDelete = (rowSelected) => {
        setRowSelected(rowSelected)
        setShowModalConfirm(true);
    }

    const onDeleteConfirm = async () => {
        if (!rowSelected) return

        const response = await deleteDepartmentContact(rowSelected?.id)
        if (response === true) {
            setShowModalConfirm(false)
            await getDataAPI()
        }
    }

    return (
        <>
            <Grid item xs={12}>
                <CustomTable
                    title={`Contactos del ${selectedDepartment?.name || 'departamento'}`}
                    columns={columns}
                    loading={loading}
                    rows={departmentContacts || []}
                    onRowClick={() => { }}
                    hasOptions
                    onAddFn={onAdd}
                    onDelete={onDelete}
                    onEdit={onEdit}
                />
            </Grid>

            {showModalConfirm && (
                <ModalConfirm
                    open={showModalConfirm}
                    closeModal={() => { setShowModalConfirm(false) }}
                    rowSelected={rowSelected}
                    onConfirm={onDeleteConfirm}
                    status2={status === ApiStatus.FETCHING}
                />
            )}
        </>
    )
}